/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Sub_AddressInputs */

const cs_property_sub_address = /** @type {(inputs: Property_Sub_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa`)
};

const en_property_sub_address = /** @type {(inputs: Property_Sub_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Property_Sub_AddressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_sub_address = /** @type {((inputs?: Property_Sub_AddressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Sub_AddressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_sub_address(inputs)
	return cs_property_sub_address(inputs)
});